import { render, staticRenderFns } from "./AgentManagement.vue?vue&type=template&id=3bbe2910&scoped=true"
import script from "./AgentManagement.vue?vue&type=script&lang=js"
export * from "./AgentManagement.vue?vue&type=script&lang=js"
import style0 from "./AgentManagement.vue?vue&type=style&index=0&id=3bbe2910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbe2910",
  null
  
)

export default component.exports